import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cw-play",
  "use": "icon-cw-play-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol viewBox=\"0 0 16 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cw-play\">\n<path d=\"M0.666663 0.666705L15.3333 10L0.666661 19.3334L0.666663 0.666705Z\" fill=\"#BABABA\" fill-opacity=\"0.729412\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/cw-play.svg
// module id = 122
// module chunks = 0 1 2